import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useHeaderFilters } from '@/features/header-filters';

import { useDispatchInProgressFilters } from '../model';
import { DispatchInProgressFilters } from './dispatch-in-progress-filters';
import { DispatchInProgressPage } from './dispatch-in-progress-page';

export function DispatchInProgressWithFilters() {
  const { t } = useTranslation();
  const { setFilterConfig, setSearchConfig } = useHeaderFilters();

  const {
    urlState,
    searchQuery,
    activeFiltersCount,
    activeFilters,
    isFiltersDirty,
    hasDefaultFilters,
    handleFilterChange,
    handleDateRangeChange,
    handleSearchChange,
    handleReset,
    handleApplyFilters
  } = useDispatchInProgressFilters();

  useEffect(() => {
    setSearchConfig({
      defaultValue: searchQuery,
      placeholder: t('gen.search.desc', 'Search among relevant properties'),
      onChange: handleSearchChange,
      enabled: true
    });
  }, [handleSearchChange, searchQuery, setSearchConfig, t]);

  useEffect(() => {
    const filterContent = (
      <DispatchInProgressFilters
        filters={urlState}
        onFilterChange={handleFilterChange}
        onDateRangeChange={handleDateRangeChange}
      />
    );

    setFilterConfig({
      id: 'dispatch-in-progress-filters',
      title: t('dispatch.inprogress.filters.title', 'Filter In-progress Dispatches'),
      content: filterContent,
      activeCount: activeFiltersCount,
      activeFilters,
      onReset: handleReset,
      onApply: handleApplyFilters,
      onClearAll: handleReset,
      isApplyDisabled: !isFiltersDirty,
      isResetDisabled: hasDefaultFilters
    });
  }, [
    activeFiltersCount,
    activeFilters,
    handleApplyFilters,
    handleDateRangeChange,
    handleFilterChange,
    handleReset,
    hasDefaultFilters,
    isFiltersDirty,
    setFilterConfig,
    t,
    urlState
  ]);

  return <DispatchInProgressPage />;
}
